import script from "./CodeCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CodeCreate.vue?vue&type=script&setup=true&lang=ts"

import "./CodeCreate.vue?vue&type=style&index=0&id=5d8e239d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8e239d"]])

export default __exports__